import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: false,
        title: '电子胶片',
      },
      component: () => import('./views/Home/Home.vue'),
    },
    {
      path: '/news',
      name: 'news',
      meta: {
        requiresAuth: false,
        title: '新闻资讯',
      },
      component: () => import('./views/Home/News.vue'),
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false,
        title: '登录',
      },
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        requiresAuth: false,
        title: '注册',
      },
      component: () => import('./views/Register.vue'),
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      meta: {
        requiresAuth: false,
        title: '忘记密码',
      },
      component: () => import('./views/ResetPassword.vue'),
    },
    {
      path: '/film',
      name: 'film',
      meta: {
        requiresAuth: true,
        title: '购买电子胶片',
      },
      component: () => import('./views/Film/Film.vue'),
    },
    {
      path: '/film-detail/:id',
      name: 'film-detail',
      meta: {
        requiresAuth: true,
        title: '购买电子胶片',
      },
      component: () => import('./views/Film/FilmDetail.vue'),
    },
    {
      path: '/share-film/:id',
      name: 'film-view',
      meta: {
        requiresAuth: false, // 分享页面不做登陆拦截
        title: '查看电子胶片',
      },
      component: () => import('./views/Film/FilmDetail.vue'),
    },
    {
      path: '/report',
      name: 'report',
      meta: {
        requiresAuth: true,
        title: '查询报告',
      },
      component: () => import('./views/Report/Report.vue'),
    },
    {
      path: '/report/:id',
      name: 'report-detail',
      meta: {
        requiresAuth: true,
        title: '查询报告',
      },
      component: () => import('./views/Report/ReportDetail.vue'),
    },
    {
      path: '/doctor-report/:id',
      name: 'doctor-report',
      meta: {
        requiresAuth: true,
        title: '名医报告',
      },
      component: () => import('./views/Report/doctorReport.vue'),
    },
    {
      path: '/doctor',
      name: 'doctor',
      meta: {
        requiresAuth: false,
        title: '专家看片',
      },
      component: () => import('./views/Doctor/Doctor.vue'),
    },
    {
      path: '/doctor/:id',
      name: 'doctor-detail',
      meta: {
        requiresAuth: false,
        title: '专家简介',
      },
      component: () => import('./views/Doctor/DoctorDetail.vue'),
    },
    {
      path: '/select-film/:id',
      name: 'select-film',
      meta: {
        requiresAuth: true,
        title: '选择检查',
      },
      component: () => import('./views/Doctor/selectFilm.vue'),
    },
    {
      path: '/payment',
      name: 'payment',
      meta: {
        requiresAuth: true,
        title: '付款',
      },
      component: () => import('./views/Payment/Payment.vue'),
    },
    {
      path: '/doctor-payment/:id',
      name: 'doctor-payment',
      meta: {
        requiresAuth: true,
        title: '付款',
      },
      component: () => import('./views/Payment/Doctor-Payment.vue'),
    },
    {
      path: '/verify/:id',
      name: 'verify',
      meta: {
        requiresAuth: true,
        title: '支付确认',
      },
      component: () => import('./views/Payment/verify.vue'),
    },
    {
      path: '/account',
      name: 'account',
      meta: {
        requiresAuth: false,
        title: '个人中心',
      },
      component: () => import('./views/Account/Account.vue'),
    },
    {
      path: '/account/user-info',
      name: 'user-info',
      meta: {
        requiresAuth: true,
        title: '修改个人信息',
      },
      component: () => import('./views/Account/UserInfo.vue'),
    },
    {
      path: '/account/card',
      name: 'card',
      meta: {
        requiresAuth: true,
        title: '就诊卡管理',
      },
      component: () => import('./views/Account/Card.vue'),
    },
    {
      path: '/account/card-detail/:id',
      name: 'card-detail',
      meta: {
        requiresAuth: true,
        title: '就诊卡管理',
      },
      component: () => import('./views/Account/CardDetail.vue'),
    },
    {
      path: '/account/card/bind',
      name: 'card-bind',
      meta: {
        requiresAuth: true,
        title: '绑定就诊卡',
      },
      component: () => import('./views/Account/CardBind.vue'),
    },
    {
      path: '/account/order',
      name: 'order',
      meta: {
        requiresAuth: true,
        title: '我的订单',
      },
      component: () => import('./views/Account/Order.vue'),
    },
    {
      path: '/account/order/:id',
      name: 'order-detail',
      meta: {
        requiresAuth: true,
        title: '我的订单',
      },
      component: () => import('./views/Account/OrderDetail.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  const openId = to.query.open_id || from.query.open_id;
  if (openId) {
    localStorage.setItem('open_id', openId);
  }
  if (to.meta.requiresAuth) {
    const authorization = localStorage.getItem('accessToken');
    if (authorization) {
      next();
    } else {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  // console.log(`after ${window.location.href}`);
});

export default router;
